import {Pipe, PipeTransform} from '@angular/core';
import {ConsentUseCaseLetterEnum} from '../../views/secured/views/modules/consent-use-case/enums/consent-use-case.enum-letter';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'levelToIntensity'
})
export class LevelToIntensityPipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(value: ConsentUseCaseLetterEnum): string {
        switch (value) {
            case 'B':
                return 'A-Level';
            case 'C':
                return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.SURFACE');
            case 'D':
                return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.NORMAL');
            case 'E':
                return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.DETAILED');
            case 'F':
                return this.translate.instant('ONBOARDING.USE_CASE_LEVELS.INTENSIV');
        }
        return value;
    }
}
